import styled from 'styled-components';

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-around;
  height: 100%;

  input::-webkit-outer-spin-button,
  input::-webkit-inner-spin-button {
    -webkit-appearance: none;
    margin: 0;
  }
`;

export const Content = styled.div`
  height: 60vh;
  overflow: auto;
`;

export const ButtonsWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  width: 100%;
  height: 10vh;
  margin-top: 16px;
  row-gap: 8px;
  bottom: 0;
  left: 0;
`;

export const RemoveButton = styled.button`
  background: rgb(235, 0, 69);
  border: none;
  border-radius: 5px;
  height: 30px;
  width: 30px;
`;

export const AddButton = styled.button`
  display: flex;
  align-items: center;
  justify-content: center;
  border: none;
  border-radius: 5px;
  width: 80px;
  height: 30px;
  background: rgb(7, 188, 12);
  color: white;
`;
